/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';

import Icon, { IconProps } from './index';

const Envelope: React.FunctionComponent<IconProps> = (props) => (
	<Icon
		{...props}
		d="M 3,3 V 21 H 21 V 3 Z M 6.5354004,6.8562012 H 17.4646 c 0.532567,0 0.964599,0.4320325 0.964599,0.9645995 V 8.831543 C 17.450007,9.59369 17.487019,9.601781 13.843506,12.246094 13.421631,12.553661 12.582228,13.294481 12,13.2854 11.417291,13.294175 10.579011,12.554183 10.156494,12.246094 6.5127794,9.601661 6.5492696,9.593087 5.5708007,8.831543 V 7.8208007 c 0,-0.532567 0.4320328,-0.9645995 0.9645997,-0.9645995 z M 5.5708007,10.464112 c 0.5608125,0.433687 1.3398072,1.014137 3.8298343,2.821288 0.569009,0.415488 1.525834,1.290824 2.599365,1.285401 1.080281,0.0054 2.049603,-0.884258 2.599365,-1.285401 2.489385,-1.806629 3.269022,-2.38764 3.829834,-2.821288 V 16.1792 c 0,0.532567 -0.432032,0.964599 -0.964599,0.964599 H 6.5354004 c -0.5325669,0 -0.9645997,-0.432032 -0.9645997,-0.964599 z"
	/>
);

export default Envelope;
